import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router';

const PrivateRoute = ({ children }) => {
  
  const isLoggedIn = localStorage.getItem('cusToken') !== null;
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if(!isLoggedIn) {
      navigate("/login", { replace: true, state: { from: `${location.pathname}${location.search}` } });
    }
  }, []);
  
  return isLoggedIn ? (
    <>{children}</>
  ) : <></>
}

export default PrivateRoute;